"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeData = void 0;
exports.getNodeData = (props) => {
    const { node, nestingLevel, selected, select, download, isOpenByDefault, } = props;
    return {
        data: {
            download,
            select,
            selected,
            id: node.value.id,
            isOpenByDefault,
            nestingLevel,
            node,
        },
        nestingLevel,
        node: node.value,
    };
};
//# sourceMappingURL=tree-utils.js.map